"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9690],{

/***/ 39690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools_Fundachart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
;// CONCATENATED MODULE: ./src/features/pro-tools/Fundachart/content.ts
var fundachartContents = [
    {
        title: "PE Standard Deviation Band",
        description: "Gunakan salah satu tools yang sering dipakai oleh institusi untuk melakukan valuasi saham. PE Standard Deviation Band berguna untuk mengetahui apakah saham sudah murah atau mahal berdasarkan PE Ratio historicalnya.",
        image: "Fundachart_PE_Std_Blue.jpg"
    },
    {
        title: "PE Price Band",
        description: "Pelajari tren harga saham berdasarkan harga yang sesuai dengan PE rasio saham tersebut. Liat apakah saham tersebut sudah murah atau mahal.",
        image: "Fundachart_PE_Price_Blue.jpg"
    },
    {
        title: "PBV Standard Deviation Band",
        description: "PBV Standard Deviation Band juga adalah salah satu tools yang sering digunakan oleh institusi untuk melakukan valuasi saham. Cari tahu saham sudah murah atau mahal berdasarkan PBV Ratio historicalnya.",
        image: "Fundachart_PBV_Blue.jpg"
    }, 
];
/* harmony default export */ var content = (fundachartContents);

;// CONCATENATED MODULE: ./src/features/pro-tools/Fundachart/index.tsx




function Fundachart() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* PageHeader */.mr, {
                title: "Fundachart",
                description: "Visualisasikan dan pelajari tren dari data fundamental perusahaan"
            }),
            content.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionBrowser */.Dr, {
                    title: content.title,
                    image: "".concat(constants/* ASSET_URL */.Z).concat(content.image),
                    description: content.description,
                    reverse: index % 2 === 0
                });
            })
        ]
    });
}
/* harmony default export */ var pro_tools_Fundachart = (Fundachart);


/***/ })

}]);